<template>
<div class="fill" ref="map" id="google-maps">
</div>
</template>

<script>
import Leaflet from 'leaflet';
import { watch } from 'vue-clamp';

export default {
    props: {
        value: {
            type: Object,
            default: () => {}
        },
        position: {
            type: Object,
            default: () => ({lat: 0, lon: 0, zoom: 3})
        },
        currentPosition: {
            type: Object,
            default: null,
        },
        originPosition: {
            type: Object,
            default: null,
        },
        destinationPosition: {
            type: Object,
            default: null,
        },
        hideZoom: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            map: null,
            marker: null,
            markerCurrent: null, //delivery marker
            markerOrigin: null, //local
            markerDestination: null, //cliente
        }
    },
    mounted() {
        this.map = Leaflet.map(this.$refs.map, {zoomControl: false}).setView([this.position.lat, this.position.lon], this.position.zoom);
        Leaflet.tileLayer(process.env.VUE_APP_TILE_PROVIDER, {
            attribution: process.env.VUE_APP_MAP_ATTRIBUTION,
            tileSize: 512,
            zoomOffset: -1
        }).addTo(this.map);

        var icon = L.icon({
            iconUrl: require('../../assets/marker_user.png'),
            iconSize: [50, 132],
            iconAnchor: [23, 64]
        });

        if(!this.hideZoom)
        {
            L.control.zoom({
                position: 'topright'
            }).addTo(this.map);
        }

        if(this.value)
        {
            this.marker = Leaflet.marker([this.value.latitude, this.value.longitude], {draggable: true, icon: icon}).addTo(this.map);
            //prevenir el menu contextual al mantener presionado en mobile
            this.marker._icon.addEventListener("contextmenu", function(event) {
                event.preventDefault();
            });
            
            this.marker.on('dragend', (e) => {
                this.$emit('OnMarkerChanged', this.marker.getLatLng());
                this.map.setView(this.marker.getLatLng(), this.map.getZoom());
            });

            this.map.on('click', (e) => {
                this.marker.setLatLng({lat: e.latlng.lat, lon: e.latlng.lng});
                this.$emit('OnMarkerChanged', this.marker.getLatLng());
                this.map.setView(this.marker.getLatLng(), this.map.getZoom());
            });
            
            this.map.setView([this.value.latitude, this.value.longitude], 15);
        }

        if(this.currentPosition)
        {
            let i = L.divIcon({
                className: 'custom-div-icon',
                html: `<div class="active-marker"></div>`,
                iconSize: [30, 30],
                iconAnchor: [15, 15]
            });
            this.markerCurrent = Leaflet.marker([this.currentPosition.latitude, this.currentPosition.longitude], {icon: i}).addTo(this.map);
        }
        if(this.originPosition)
        {
            let i = L.divIcon({
                className: 'custom-div-icon',
                html: `<div class="round-marker" style="background-image: url(${this.Util.img(this.originPosition.logotype, 'logos')})"></div>`,
                iconSize: [50, 50],
                iconAnchor: [25, 25]
            });
            this.markerOrigin = Leaflet.marker([this.originPosition.latitude, this.originPosition.longitude], {icon: i}).addTo(this.map);
        }
        if(this.destinationPosition)
        {
            this.markerDestination = Leaflet.marker([this.destinationPosition.latitude, this.destinationPosition.longitude], {icon: icon}).addTo(this.map);
        }
        this.UpdateMarkers();
        
    },
    methods: {
        GeoLocation() {
            navigator.geolocation.getCurrentPosition((pos) => {
                if(pos && pos.coords)
                {
                    this.FlyTo(pos.coords);
                    this.$emit('OnMarkerChanged', {lat: pos.coords.latitude, lng: pos.coords.longitude});
                }
            });
        },
        FlyTo(point)
        {
            this.marker.setLatLng({lat: point.latitude, lon: point.longitude});
            this.map.setView(this.marker.getLatLng(), this.map.getZoom());
        },
        UpdateMarkers()
        {
            let markers = [];
            if(this.markerCurrent)
            {
                this.markerCurrent.setLatLng({lat: this.currentPosition.latitude, lon: this.currentPosition.longitude});
                markers.push([this.currentPosition.latitude, this.currentPosition.longitude]);
            }
            if(this.markerOrigin)
            {
                //markers.push([parseFloat(this.originPosition.latitude), parseFloat(this.originPosition.longitude)]);
            }
            if(this.markerDestination)
            {
                markers.push([this.destinationPosition.latitude, this.destinationPosition.longitude]);
            }

            if(markers.length)
            {
                let bounds = Leaflet.latLngBounds(markers);
                this.map.fitBounds(bounds);
            }
        }
    },
    watch: {
        currentPosition: function(n, o) {
            if(n) this.UpdateMarkers();
        }
    },
    beforeDestroy() {
        if(this.map)
        {
            this.map.remove();
            this.map = null;
        }
    },
}
</script>

<style lang="scss">
.leaflet-right .leaflet-control {
    margin-right: 20px !important;
}
.leaflet-top .leaflet-control {
    margin-top: 20px !important;
}
.custom-div-icon {
  background: transparent;
  border: none;
}
.round-marker {
    background: white;
    border-radius: 50%;
    width: 100%;
    height: 100%;
    border: 3px solid white;
    box-shadow: 0 2px 6px rgba(0,0,0,0.3);
    background-size: contain;
}
.active-marker {
    background: #4285f4;
    border-radius: 50%;
    width: 100%;
    height: 100%;
    border: 3px solid white;
    position: relative;
    &::before {
        content: '';
        background: #4285f4;
        border-radius: 50%;
        position: absolute;
        width: 100%;
        height: 100%;
        animation: anim-pulse 1s linear 0s infinite;
    }
}
@keyframes anim-pulse {
    0% {
        opacity: 0.6;
        transform: scale(1);
    }
    100% {
        opacity: 0;
        transform: scale(2.5);
    }
}
</style>
